import type { FaireProductEntity } from "../../entity_types/product";

export const p_cdzw8zyeyx: FaireProductEntity = {
  token: "p_cdzw8zyeyx",
  type: "product",
  name: "Mocha Floral Skort - Kids Boutique Clothing - Fall",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/c3c18b5eff2a51aa3ff02c42acbffc331f15cd3c7b3de74384ccd57441ff4b20.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2075051c50d526af54f95d79ae728e0be672c3ec7bae298a6c2c262dd69937fe.jpeg",
    "https://cdn.faire.com/fastly/5edc32037d005769affee872c8869d6fb91f3ace5ba25b522d2ed0c30b2ec8f2.jpeg",
    "https://cdn.faire.com/fastly/021404efe674b14ef38989c2f55549243fa07c60c0c2fe9fbed6dc37c70a3356.jpeg",
    "https://cdn.faire.com/fastly/09c39db149c96589f994bee55c76870198bc52482f1f831e41b77d1b51256659.jpeg",
    "https://cdn.faire.com/fastly/565f87e55e6569b8ae5e85cb5ce356a83753fe9bfca3350986bc64319fe45b54.jpeg",
    "https://cdn.faire.com/fastly/b6ee616ce8196487494b2e108af4a3208a095066d6891b2eaa771281201e1409.jpeg",
  ],
  priceDollars: 20,
  description:
    "Twirl-ready and full of sweetness, this layered skort brings all the playful movement and charm to every little moment.\n\nFeatures:\n * Mocha skort with ivory flowers and a delicate lace trim \n * 2 ruffled tiers with attached shorts inside \n * Smocked waistband \n * Care: Machine washable, lay flat to dry ",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:17.827Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
